<script lang="ts" setup>
const menu: {
  text: string
  url: string
}[] = [
  {
    text: 'CSM/szkoła',
    url: 'https://csmszkola.pl',
  },
  {
    text: 'CSM/conf',
    url: 'https://csmconf.pl/',
  },
  {
    text: 'CSM/online',
    url: 'https://csmonline.edu.pl/',
  },
  /*{
    text: 'CSM/worship',
    url: 'https://csmworship.pl/',
  },*/
  {
    text: 'Sklep',
    url: 'https://www.sklep.csmworship.pl/',
  },
  {
    text: 'Wesprzyj nas',
    url: '/wesprzyj-nas',
  },
]

function isInternal(url: string) {
  return url.startsWith('/')
}

const drawer = shallowRef(false)

const drawerWidth = ref(320)

onMounted(() => {
  drawerWidth.value = window.innerWidth

  window.addEventListener('resize', () => {
    drawerWidth.value = window.innerWidth
  })
})
</script>

<template>
  <v-app-bar
    :height="56"
    :extension-height="1"
    flat
  >
    <v-container>
      <div class="d-flex align-center ga-6 flex-grow-1">
        <ui-logo />
        <v-spacer />
        <div
          class="d-none d-md-flex align-center justify-center"
          :style="{
            position: 'absolute',
            transform: 'translateX(-50%)',
            left: '50%',
          }"
        >
          <v-btn
            v-for="item in menu"
            :key="item.text"
            :to="isInternal(item.url) ? item.url : undefined"
            :href="!isInternal(item.url) ? item.url : undefined"
            :target="!isInternal(item.url) ? '_blank' : undefined"
            :rel="!isInternal(item.url) ? 'noopener' : undefined"
            :text="item.text"
            exact
          />
        </div>
        <v-app-bar-nav-icon
          v-if="$vuetify.display.smAndDown"
          @click="drawer = !drawer"
        />
      </div>
    </v-container>
    <template #extension>
      <v-divider opacity="1" color="gray-300" />
    </template>
  </v-app-bar>
  <v-navigation-drawer
    v-if="$vuetify.display.smAndDown"
    v-model="drawer"
    disable-resize-watcher
    disable-route-watcher
    location="end"
    touchless
    :scrim="false"
    :width="drawerWidth"
  >
    <div class="d-flex flex-column mt-8 ga-4">
      <v-btn
        v-for="item in menu"
        :key="item.text"
        variant="text"
        :to="isInternal(item.url) ? item.url : undefined"
        :href="!isInternal(item.url) ? item.url : undefined"
        :target="!isInternal(item.url) ? '_blank' : undefined"
        :rel="!isInternal(item.url) ? 'noopener' : undefined"
        :text="item.text"
        exact
        :ripple="false"
        size="x-large"
        class="text-h6 font-weight-medium"
        @click="drawer = false"
      />
    </div>
  </v-navigation-drawer>
</template>
